// extracted by mini-css-extract-plugin
module.exports = {"Page":"styles_Page__mxxH_","cloudPage":"styles_cloudPage__weDJr","darkMode":"styles_darkMode__IdJ_i"};